export default __webpack_public_path__ + "static/media/noti.89697192.svg";